import { useParams, useLocation } from 'react-router-dom';
import SolicitacaoDetailsContent from './SolicitacaoDetailsContent';
import type { SolicitacaoDetailsPageProps } from './solicitacaoDetailsPage.types';

/**
 * Wrapper de rota (`/si/solicitacoes/:id`) — mantém o deep-link/URL direta funcionando.
 * A lista abre o mesmo conteúdo num drawer (ver SolicitacaoDrawer), sem navegar; esta
 * página continua existindo pra quem acessa a URL diretamente (compartilhada, favoritos)
 * — nesse caso mostra a visão completa de execução do SI por padrão.
 *
 * Exceção: logo após criar (ver NovaSolicitacaoPage), a navegação passa
 * `state.forcarVisaoSolicitante` — quem acabou de criar agiu como solicitante, não
 * importa se tem role de SI.
 */
export default function SolicitacaoDetailsPage({ className }: SolicitacaoDetailsPageProps) {
  const { id } = useParams<{ id: string }>();
  const location = useLocation();
  const forcarVisaoSolicitante = Boolean((location.state as { forcarVisaoSolicitante?: boolean } | null)?.forcarVisaoSolicitante);

  return <SolicitacaoDetailsContent id={id} className={className} forcarVisaoSolicitante={forcarVisaoSolicitante} />;
}
